import React, { FC, useLayoutEffect } from 'react'
import { ModalProps } from 'antd/lib/modal'
import { Modal as AntModal } from 'antd'
import './modal.ant.scss'
import { ModalFunc } from 'antd/lib/modal/confirm'

const setScrollbarCompensation = () => {
  if (typeof window === 'undefined' || document.body.classList.contains('ant-scrolling-effect')) {
    return
  }

  const scrollbarWidth = Math.max(window.innerWidth - document.documentElement.clientWidth, 0)
  document.body.style.setProperty('--modal-scrollbar-compensation', `${scrollbarWidth}px`)
}

const withScrollbarCompensation =
  (modal: ModalFunc): ModalFunc =>
  (props) => {
    setScrollbarCompensation()
    return modal(props)
  }

interface ModalComponent extends FC<ModalProps> {
  success: ModalFunc
  info: ModalFunc
  warning: ModalFunc
  error: ModalFunc
  confirm: ModalFunc
  useModal: typeof AntModal.useModal
  destroyAll: typeof AntModal.destroyAll
}

const Modal: ModalComponent = (props) => {
  useLayoutEffect(() => {
    if (props.visible) setScrollbarCompensation()
  }, [props.visible])

  return <AntModal {...props} />
}

Modal.success = withScrollbarCompensation(AntModal.success)
Modal.info = withScrollbarCompensation(AntModal.info)
Modal.warning = withScrollbarCompensation(AntModal.warning)
Modal.error = withScrollbarCompensation(AntModal.error)
Modal.useModal = AntModal.useModal
Modal.confirm = withScrollbarCompensation(AntModal.confirm)
Modal.destroyAll = AntModal.destroyAll
export default Modal
